<template>
  <div>
    <div ref="loadingScreen" :class="{ 'loading-screen': showLoadingScreen, 'loading-screen fade-out': !showLoadingScreen }">
      <div v-if="showLoadingScreen" class="loading-icon"></div>
    </div>
    <b-icon
      v-b-toggle.sidebar-right
      icon="justify"
      variant="primary"
      class="h2 position-fixed"
      style="cursor: pointer; top: 20px; right: 20px; z-index: 10000"
      @click="showSideBar"
    ></b-icon>

    <b-sidebar
      ref="sidebarRight"
      id="sidebar-right"
      right
      shadow
      :no-header-close="true"
      :visible="true"
      style="z-index: 10000000"
    >
      <template #header="{ hide }">
        <b-button
          variant="outline-default"
          @click="hide"
          class="position-absolute"
          style="right: 20px; top: 15px; padding: 0; background: white;"
        >
          <b-icon
            v-b-toggle.sidebar-right
            icon="x-lg"
            @click="hideSideBar"
            style="
              padding: 5px 5px 5px 6px;
              box-sizing: content-box;
              border: 1px solid #00000060;
              border-radius: 5px;
              position: relative;
              z-index: 1000;
            "
          ></b-icon>
        </b-button>
      </template>
      <template #default>
        <div class="px-3 py-2">
          <div class="mb-3">
            <label
              class="form-label font-weight-bold mr-2"
            >
              案場名稱
            </label>

            <select
              v-model="caseScene"
              class="form-select"
              @change="changeCaseScene"
            >
              <option
                v-for="item in resources.caseScenes"
                :value="item.id"
                :key="item.id"
              >
                {{ item.name }} {{ item.device_capacity }} {{ item.capacity_unit }}
              </option>
            </select>
          </div>

          <table class="table table-bordered table-sm text-center my-3">
            <thead>
              <tr>
                <td>裝置容量</td>
                <td>模組廠牌</td>
                <td>模組型號</td>
                <td>模組片數</td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in resources.caseScenes"
                :key="item.id"
              >
                <template v-if="caseScene === item.id">
                  <td>{{ item.device_capacity }} {{ item.capacity_unit }}</td>
                  <td>{{ item.module_brand }}</td>
                  <td>{{ item.module_model }}</td>
                  <td>{{ item.module_total }}</td>
                </template>
              </tr>
            </tbody>
          </table>

          <div class="mb-3">
            <label class="form-label font-weight-bold mr-2">檢測時間</label>

            <select v-model="detection" class="form-select" @change="changeDetectionDate">
              <template
                v-for="item in resources.detections"
              >
                <option
                  v-if="caseScene === item.case_scene_id"
                  :key="item.id"
                  :value="item.id"
                >
                <!--{{ item.detection_date.split(' ')[0] }}-->
                {{ item.detection_date }}
                </option>
              </template>
            </select>
          </div>

          <table v-if="detection" class="table table-bordered table-sm text-center my-3">
            <thead>
              <tr>
                <td>天氣狀況</td>
                <td>日照 W/m<sup>2</sup></td>
                <td>氣溫 ℃</td>
                <td>雲遮蔽 %</td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in resources.detections"
                :key="item.id"
              >
                <template v-if="detection === item.id">
                  <td>{{ item.weather_name }}</td>
                  <td>{{ item.sunshine }}</td>
                  <td>{{ item.temperature }}</td>
                  <td>{{ item.cloud_obscuration }}</td>
                </template>
              </tr>
            </tbody>
          </table>

          <video
            v-if="detection"
            :src="`https://${rootUrl}/uploads/videos/${resources.detections.find(element => element.id === detection).video}`"
            controls
            style="height: auto; width: 100%"
          ></video>
          <ul style="padding-left: 1rem; padding-top: 0.5rem; font-size: 0.85rem;">
            <li>無人機檢測路徑與白熱模式熱影像快轉播放，點擊選項可降低速度。</li>
          </ul>

          <div class="mt-3 font-weight-bold">檢測結果</div>

          <table
            v-if="thermalDefectCategory.length"
            class="table table-bordered table-sm caption-top text-center my-3"
          >
            <thead>
              <tr>
                <td>熱缺陷種類</td>
                <td>片數</td>
                <td>比率 %</td>
                <td>顯示</td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in thermalDefectCategory"
                :key="item.id"
              >
                <td style="position: relative" >
                  <span :style="`position: absolute; left: 5px; top: 9px; width: 15px; height: 15px; border-radius: 100%; background-color: ${item.color};`"></span>
                  <span>{{ item.name }}</span>
                </td>
                <td>{{ item.quantity }}</td>
                <td>
                  {{ (item.quantity / resources.caseScenes.find(element => element.id === caseScene).module_total * 100).toFixed(2) }}
                </td>
                <td>
                  <b-form-checkbox
                    v-model="item.show"
                    :value="true"
                    :unchecked-value="false"
                    @change="toggleDefect(item)"
                  ></b-form-checkbox>
                </td>
              </tr>
            </tbody>
          </table>
          <p v-else class="mt-2 text-danger">恭喜您，本次檢測無發現熱缺陷。</p>

          <p v-if="resources.detections.length && resources.detections.find(element => element.id == detection).note">備註：{{ resources.detections.find(element => element.id == detection).note }}</p>
          
          <ul style="padding-left: 1rem; padding-top: 0.5rem; font-size: 0.85rem;">
            <li>12 種熱缺陷分類與正射圖定位(點擊關閉鍵後顯示)。</li>
            <li>熱斑 (Hot Spot) 標定原則為異常點溫度高於正常區域 20 度以上。</li>
            <li>受數值地表模型 (DSM) 準確度影響，若正射影像出現變形為正常現像，非實際缺陷。</li>
            <li v-if="detection">此頁正射圖產生 @ {{ resources.detections.find(element => element.id == detection).orthophoto_date }}。</li>
          </ul>

          <div class="mt-3 font-weight-bold">維運日誌</div>

          <table
            class="table table-bordered table-sm caption-top text-center mt-3 mb-2"
          >
            <thead>
              <tr>
                <td>人員</td>
                <td>內容</td>
                <td>日期</td>
                <td>功能</td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item of resources.maintainLogs"
                :key="item.id"
              >
                <td>
                  <span
                    v-if="item.updated_user_name"
                  >
                    {{ item.updated_user_name }}
                  </span>
                  <span
                    v-else
                  >
                    {{ item.created_user_name }}
                  </span>                  
                </td>
                <td>
                  <b-form-textarea
                    v-model="item.note"
                    rows="2"
                  ></b-form-textarea>
                </td>
                <td>
                  <span
                    v-if="item.updated_at"
                  >
                    <vue2-date-picker
                      v-model="item.updated_at"
                      format="YYYY-MM-DD"
                      :append-to-body="false"
                      :clearable="false"
                      style="width: 115px;"
                    ></vue2-date-picker>
                  </span>
                  <span
                    v-else
                  >
                    <vue2-date-picker
                      v-model="item.created_at"
                      format="YYYY-MM-DD"
                      :append-to-body="false"
                      :clearable="false"
                      style="width: 115px;"
                    ></vue2-date-picker>                
                  </span>
                </td>
                <td>
                  <b-button
                    size="sm"
                    variant="outline-primary mb-1"
                    @click="updateMaintainLog(item)"
                  >更新</b-button>

                  <br>

                  <b-button
                    size="sm"
                    variant="outline-danger"
                    @click="deleteMaintainLog(item.id)"
                  >刪除</b-button>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <b-form-textarea
                    v-model="note"
                    rows="2"
                  ></b-form-textarea>
                </td>
                <td>
                  <vue2-date-picker
                    v-model="today"
                    format="YYYY-MM-DD"
                    :append-to-body="false"
                    :clearable="false"
                    style="width: 115px;"
                  ></vue2-date-picker>
                </td>
                <td>
                  <b-button
                    @click="storeMaintainLog"
                    variant="outline-primary"
                    size="sm"
                    :disabled="!(today && note)"
                  >新增</b-button>
                </td>
              </tr>              
            </tbody>
          </table>

          <ul style="padding-left: 1rem; padding-top: 0.5rem; font-size: 0.85rem;">
            <li>內容新增後將保存在雲端供公司其他用戶參考。</li>
          </ul>

          <b-row>
            <b-col cols="12" class="text-right">
              <b-button-group>
                <b-button v-b-tooltip.hover title="歷次檢測比較" @click="openModal">
                  <b-icon icon="graph-up"></b-icon>
                </b-button>
                <a href="/report" target="_blank">
                  <b-button v-b-tooltip.hover title="PDF 報告" style="border-radius: 0;">
                    <b-icon icon="file-earmark-pdf"></b-icon>
                  </b-button>
                </a>
                <a v-if="resources.detections.length" :href="`https://${rootUrl}/uploads/videos/${resources.detections.find(element => element.id === detection).video}`" download="影片下載">
                  <b-button v-b-tooltip.hover title="影片下載" style="border-radius: 0;">
                    <b-icon icon="camera-reels"></b-icon>
                  </b-button>
                </a>
                <a v-if="resources.detections.length" :href="`https://${rootUrl}/uploads/case-scene-photos/${resources.detections.find(element => element.id == detection).case_scene_photo}`" download="空拍圖下載">
                  <b-button v-b-tooltip.hover title="空拍圖下載" style="border-radius: 0;">
                    <b-icon icon="card-image"></b-icon>
                  </b-button>
                </a>
                <a v-if="resources.detections.length" :href="`https://${rootUrl}/uploads/orthophotos/${resources.detections.find(element => element.id == detection).orthophoto}`" download="正射圖下載">
                  <b-button v-b-tooltip.hover title="正射圖下載" style="border-radius: 0;">
                    <b-icon icon="map"></b-icon>
                  </b-button>
                </a>
                <a href="/taiwan-map">
                  <b-button v-b-tooltip.hover title="回上層" style="border-radius: 0;">
                    <b-icon icon="arrow90deg-left"></b-icon>
                  </b-button>
                </a>
                <a v-if="isAdmin" href="/admin/company">
                  <b-button v-b-tooltip.hover title="返回管理面板" style="border-radius: 0;">
                    <b-icon icon="gear"></b-icon>
                  </b-button>
                </a>
                <b-button v-b-tooltip.hover title="登出帳號" @click="logout()">
                  <b-icon icon="door-open"></b-icon>
                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </div>
      </template>
    </b-sidebar>

    <b-row>
      <b-col cols="8">
        <div id="image-map-pro"></div>
      </b-col>
      <b-col>
      </b-col>
    </b-row>

    <!-- Chart Modal Component -->
    <b-modal
      ref="chartContainer"
      id="chart-container" 
      v-model="modalOpen" 
      @hide="clearModalContent"
      hide-footer
      hide-header
      centered
      size="xl"
    >
      <button type="button" class="modal-close" aria-label="Close" @click="modalOpen = false">
        <span aria-hidden="true">&times;</span>
      </button>
      <!-- Modal Content (Dynamic Component) -->
      <component :is="modalComponent" v-if="modalComponent"/>
    </b-modal>
  </div>
</template>

<script>
import Vue2DatePicker  from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-cn';

import Chart from './ChartView.vue'; // Import the Chart component

export default {
  components: {
    Vue2DatePicker,
    Chart // Register the Chart component
  },
  data() {
    return {
      rootUrl: 'platform.iruav.com.tw',
      caseScene: null,
      detection: null,
      today: new Date(),
      note: null,
      thermalDefect: null,
      thermalDefectCategory: [],
      showLoadingScreen: true,
      modalOpen: false,
      modalComponent: null,
      isAdmin: false,
      resources: {
        caseScenes: [],
        detections: [],
        thermalDefects: [],
        maintainLogs: []
      },
      imageMapPro: {
        id: "imp-main",
        fullscreen: {
          enable_fullscreen_mode: true,
          vstart_in_fullscreen_mode: true,
          start_in_fullscreen_mode: true,
        },
        objectConfig: {
          pageload_animation: "flash",
          glowing_objects: true,
        },
        tooltips: {
          sticky_tooltips: true,
          fullscreen_tooltips: "none",
        },
        zooming: {
          enable_zooming: true,
          max_zoom: 15,
          zoom_on_object_click: true,
          hold_ctrl_to_zoom: false,
        },
        artboards: [
          {
            title: null,
            background_type: 'image',
            image_url: null,
            use_image_size: true,
            children: [],
          },
        ],
        version: "6.0.18",
        general: {
          name: "imp-case-scene",
        },
      }
    }
  },
  methods: {
    /**
     * Handle right sidebar close
     */
    hideSideBar() {
      let impCanvas = document.querySelector('[data-image-map-name="imp-case-scene [fullscreen]"] .imp-canvas');

      if (impCanvas) {
        impCanvas.style.marginLeft = "0px";
      }
    },

    /**
     * Handle right sidebar open
     */
    showSideBar() {
      let impCanvas = document.querySelector('[data-image-map-name="imp-case-scene [fullscreen]"] .imp-canvas');

      if (impCanvas) {
        impCanvas.style.marginLeft = "-500px";
      }
    },

    /**
     * Point display block or none
     */
    toggleDefect(item) {
      let imageMap = document.querySelector('[data-image-map-id="imp-main [fullscreen]"] .imp-objects');
      let titles = imageMap.querySelectorAll(`[data-title="thermal-defect-category-${item.id}"]`);

      for (let i = 0, len = titles.length; i < len; i++) {
        if (item.show) {
          titles[i].style.display = 'flex';
        } else {
          titles[i].style.display = 'none';
        }
      }
    },

    /**
     * Initialize Image Map Pro
     */    
    setImageMapPro() {
      /**
       * 1st clean all the nodes if they exist
       */
      let impCanvas = document.querySelector("#imp-fullscreen-image-map .imp-canvas");
      let impButton = document.querySelector("#imp-fullscreen-image-map .imp-fullscreen-button");
      
      // Check if the node exists
      if (impCanvas) {
        impCanvas.remove(); // Remove the node if it exists
      }

      // Check if the node exists
      if (impButton) {
        impButton.remove(); // Remove the node if it exists
      }

      this.imageMapPro.artboards[0].title = this.resources.caseScenes.find(element => element.id == this.caseScene).name;
      this.imageMapPro.artboards[0].image_url = `https://${this.rootUrl}/uploads/orthophotos/${this.resources.detections.find(element => element.id == this.detection).orthophoto}`;
      this.imageMapPro.artboards[0].children = [];
      this.thermalDefectCategory = [];

      for (let i = 0, len = this.resources.thermalDefects.length; i < len; i++) {
        let index = this.thermalDefectCategory.findIndex(element => element.id == this.resources.thermalDefects[i].thermal_defect_category_id);
        
        if (index === -1) {
          this.thermalDefectCategory.push({
            id: this.resources.thermalDefects[i].thermal_defect_category_id,
            name: this.resources.thermalDefects[i].thermal_defect_category_name,
            description: this.resources.thermalDefects[i].thermal_defect_category_description,
            color: this.resources.thermalDefects[i].thermal_defect_category_color,
            quantity: 1,
            show: true
          });
        } else {
          this.thermalDefectCategory[index].quantity++;
        }
      }

      this.thermalDefectCategory.sort((a, b) => {
        if (a.quantity !== b.quantity) {
            return b.quantity - a.quantity; // Sort by quantity, high to low
        } else {
            return a.id - b.id; // If quantities are the same, sort by id
        }
      });

      for (let i = 0, len = this.resources.thermalDefects.length; i < len; i++) {
        this.imageMapPro.artboards[0].children.push({
          id: `imp-point-${i + 1}`,
          title: `thermal-defect-category-${this.resources.thermalDefects[i].thermal_defect_category_id}`,
          x: this.resources.thermalDefects[i].grid_x,
          y: this.resources.thermalDefects[i].grid_y,
          default_style: {
            icon_size: 13,
            icon_svg:
              '<svg xmlns="http://www.w3.org/2000/svg" style="border: 1px solid white; border-radius: 100%; box-shadow: white 0px 0px 0px 1px inset;" viewBox="0 0 512 512"><!--! Font Awesome Free 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. --><path d="M512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256z"/></svg>',
            icon_fill: this.resources.thermalDefects[i].thermal_defect_category_color,
            icon_is_pin: false, // Important to get icon centered on position
          },
          tooltip_style: {
            position: 'top',
          },
          tooltip_content: [
            {
              type: 'Image',
              url: `https://${this.rootUrl}/uploads/combine-photos/${this.resources.thermalDefects[i].combine_photo}`,
              linkUrl: '',
              other: {
                id: '',
                classes: '',
                css: 'max-width:370px;',
              },
              boxModel: {
                width: 'auto',
                height: 'auto',
                margin: {
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                },
                padding: {
                  top: 10,
                  bottom: 10,
                  left: 10,
                  right: 10,
                },
              },
              id: null,
            },
            {
              type: 'Paragraph',
              text: this.resources.thermalDefects[i].thermal_defect_category_name,
              other: {
                id: '',
                classes: '',
                css: '',
              },
              style: {
                fontFamily: 'sans-serif',
                fontSize: 16,
                lineHeight: 22,
                color: '#ffffff',
                textAlign: 'center',
              },
              boxModel: {
                width: 'auto',
                height: 'auto',
                margin: {
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                },
                padding: {
                  top: 10,
                  bottom: 10,
                  left: 10,
                  right: 10,
                },
              },
              id: null,
            },
            {
              type: 'Paragraph',
              text: this.resources.thermalDefects[i].thermal_defect_category_description,
              other: {
                id: '',
                classes: '',
                css: 'max-width:370px;',
              },
              style: {
                fontFamily: 'sans-serif',
                fontSize: 14,
                lineHeight: 22,
                color: '#ffffff',
                textAlign: 'left',
              },
              boxModel: {
                width: 'auto',
                height: 'auto',
                margin: {
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                },
                padding: {
                  top: 10,
                  bottom: 10,
                  left: 10,
                  right: 10,
                },
              },
              id: null,
            },
          ],
        });
      }
      
      window.ImageMapPro.init("#image-map-pro", this.imageMapPro);

      /**
       * This is the function that loops until fullscreen container is detected
       */
      let intervalCanvas = setInterval(() => {
        impCanvas = document.querySelector('#imp-fullscreen-image-map .imp-canvas');

        if (impCanvas) {
          clearInterval(intervalCanvas);  // Stop the interval once the element is found
          impCanvas.style.marginLeft = '-500px';
          impCanvas.style.transition = 'margin-left 0.5s ease';
        }
      }, 100);

      /**
       * This is the function that loops until fullscreen button is detected
       */
      let intervalButton = setInterval(() => {
        impButton = document.querySelector('#imp-fullscreen-image-map .imp-fullscreen-button');

        if (impButton) {
          clearInterval(intervalButton);  // Stop the interval once the element is found
          impButton.style.display = 'none';

          // Remove loading screen 
          if (this.showLoadingScreen) { 
            this.removeLoadingScreen();
          }
        }
      }, 100);
    },

    /**
     * 案場
     */
    getCaseScene() {
      const userData = JSON.parse(localStorage.getItem('user'));
      let companyId = userData.company_id;
      let isAdmin = userData.admin;
      if (isAdmin === 1) {
        this.isAdmin = true;
      }
      //const companyId = parseInt(localStorage.getItem('CompanyId'), 10);
      const caseSceneId = parseInt(localStorage.getItem('CaseSceneId'), 10);

      let filterParam = companyId !== 14 ? `company_id:${companyId}` : 'is_demo:1';

      this.axios.get('/case-scene', { params: {
        //filter : `company_id:${companyId}`
        filter: filterParam
      }})
      .then(response => {
        this.resources.caseScenes = response.data.data;
        this.caseScene = caseSceneId;

        this.getDetection();
      })
      .catch(error => {
        console.log(error);
      });
    },

    /**
     * 檢測
     */
     getDetection() {
      this.axios.get('/detection', { params: {
        filter : `case_scene_id:${this.caseScene}`,
        sort: '-id'
      }})
      .then(response => {
        this.resources.detections = response.data.data;
        this.detection = this.resources.detections[0].id;
        localStorage.setItem('DetectionId', JSON.stringify(this.detection));

        this.getThermalDefect();
      })
      .catch(error => {
        console.log(error);
      });
    },

    /**
     * 熱缺陷
     */
    getThermalDefect () {
      this.axios.get('/thermal-defect', { params: {
        filter: `thermal_defect.detection_id:${this.detection}`
      }})
        .then(response => {
          this.resources.thermalDefects = response.data.data;

          this.setImageMapPro();
          this.hideSideBar();
          this.getMaintainLogs();
        })
        .catch(error => {
          console.log(error);
        });
    },

    /**
     * 維護日誌
     */
    getMaintainLogs () {
      this.axios.get('/maintain-log', { params: {
        filter: `maintain_log.detection_id:${this.detection}`,
        sort: '-maintain_log.updated_at,-maintain_log.created_at'
      }})
        .then(response => {
          response.data.data.forEach(element => {
            element.created_at = element.created_at ? new Date(element.created_at) : null
            element.updated_at = element.updated_at ? new Date(element.updated_at) : null
          })

          this.resources.maintainLogs = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    /**
     * 【新增】維護日誌
     */
    storeMaintainLog () {
      this.axios.post(`/maintain-log`, {
        created_at: this.today.format('Y-m-d H:i:s'),
        note: this.note,
        detection_id: this.detection,
        created_user: this.$store.state.user.id
      })
        .then((response) => {
          response.data.data[0].created_at = new Date(response.data.data[0].created_at);
          this.resources.maintainLogs.splice(0, 0, response.data.data[0]);
          this.today = new Date();
          this.note = null;
          this.makeToast('系統訊息', 'success', '新增成功！');
        })
        .catch(error => {
          console.log(error);
        });
    },

    /**
     * 【更新】維護日誌
     */
    updateMaintainLog (item) {
      this.axios.patch(`/maintain-log/${item.id}`, {
        updated_at: item.created_at ? item.created_at.format('Y-m-d H:i:s') : item.updated_at.format('Y-m-d H:i:s'),
        note: item.note,
        updated_user: this.$store.state.user.id
      })
        .then((response) => {
          item.updated_user = new Date(response.data.data[0].updated_user);
          item.updated_at = new Date(response.data.data[0].updated_at);
          this.makeToast('系統訊息', 'success', '資料已更新！');
        })
        .catch(error => {
          console.log(error);
        });
    },

    /**
     * 【刪除】維護日誌
     */
    deleteMaintainLog (id) {
      if (confirm("確定刪除！")) {
        this.axios
          .delete(`/maintain-log/${id}`)
          .then(() => {
            const index = this.resources.maintainLogs.findIndex(
              (element) => element.id == id
            );
            this.resources.maintainLogs.splice(index, 1);

            this.makeToast("系統訊息", "success", "刪除成功！");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    changeCaseScene () {   
      localStorage.setItem('CaseSceneId', JSON.stringify(this.caseScene));
      this.getDetection();
    },

    changeDetectionDate () {
      localStorage.setItem('DetectionId', JSON.stringify(this.detection));
      this.getThermalDefect();
    },

    /**
     * Manage chart modal
     */      
    openModal() {
      this.modalOpen = true;
      this.modalComponent = Chart; // Load /chart content when modal opens
      this.$nextTick(() => {
        const modalDialog = document.querySelector("#chart-container #chart-container___BV_modal_body_");
        if (modalDialog) {
          modalDialog.style.cssText += 'height: 80vh; max-height: 80vh; border: 16px solid white; padding: 0; border-radius: .5rem; background: #100c2a;';
        }
      });
    },
    clearModalContent() {
      this.modalComponent = null;
    },

    /**
     * Remove loading screen
     */         
    removeLoadingScreen() {
      this.showLoadingScreen = false;
      setTimeout(() => {
        const loadingScreen = this.$refs.loadingScreen;
        if (loadingScreen) {
          loadingScreen.remove();
        }
      }, 500);
    },

    /**
     * Logout
     */   
    logout () {
      const config = {
        headers: { Authorization: `Bearer ${ localStorage.getItem('token') }` }
      };

      this.axios
        .get('/logout', config)
        .then((response) => {
          if (response.status === 200) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');

            this.$store.commit('setToken', null);
            this.$store.commit('setUser', {});

            // Important, remove Image Map Pro element with id "imp-fullscreen-container"
            const element = document.getElementById('imp-fullscreen-container');
            if (element) {
              element.parentNode.removeChild(element);
            }

            // Redirect to login page
            this.$router.push({ path: '/login' });
          } else {
            console.error('Logout failed:', response.data); // Log response data for debugging
          }
        })
        .catch(error => {
          console.error('Logout error:', error);
        });
    },
  },
  mounted() {
    /**
     * Function to prevent drag and drop of the map if the mouse is on the sidebar
     */
    var sidebar = this.$refs.sidebarRight.$el;
    // sidebar.addEventListener("mousedown", function (event) {
    //   event.stopPropagation();
    // });

    /**
     * Fix textarea touch issue on mobile
     */   
    this.$nextTick(() => {
      sidebar.querySelectorAll('textarea').forEach((textarea) => {
        textarea.addEventListener('touchstart', (event) => {
          event.stopPropagation();
        });
      });
    });

    /**
     * Prevent touch events and wheel events from propagating to the map
     */
    sidebar.addEventListener('touchmove', (event) => {
      event.stopPropagation();
    }, { passive: false });
    sidebar.addEventListener('wheel', (event) => {
      event.stopPropagation();
    });

    /**
     * Function to solve the esc problem: reload the map
     */
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        // Reload Image Map Pro
        this.setImageMapPro();
        // In case we are on the right sidebar, it will close on esc, we need to open it again
        setTimeout(() => {
          sidebar.style.display = "block"; 
        }, 2000); 
      }
    });

    this.getCaseScene();

    setTimeout(() => {
      this.getMaintainLogs();
    }, 2000)
  },
};
</script>

<style scoped>
.table th,
.table td {
  vertical-align: middle;
}
.mx-datepicker-popup {
  z-index: 99999 !important
}
.b-icon.bi-justify {
  background: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  border: 1px solid #00000060;
  border-radius: 5px;
  fill: black;
}
.b-sidebar-outer >>> #sidebar-right {
  width: 100%;
}
/* desktop */
@media (min-width: 960px) {
  .b-sidebar-outer >>> #sidebar-right {
    width: 500px;
  }
}
#sidebar-right thead tr {
  background-color: #e5e5e5;
}
#sidebar-right thead tr td {
  background-color: inherit;
}
#chart-container___BV_modal_outer_ {
  z-index: 99999!important;
}
#chart-container___BV_modal_body_, .modal-body {
  height: 80vh;
  max-height: 80vh;
  border: 16px solid white;
  padding: 0;
  border-radius: .5rem;
}
.modal-close {
  position: absolute;
  top: 60px;
  right: 20px;
  background-color: white;
  border: none;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 99999;
}
.modal-close span {
  font-size: 40px;
  color: #333;
  line-height: 27px;
}
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #100c2a;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  z-index: 20000;
  transition: opacity .5s; 
  opacity: 1;
}
.loading-screen.fade-out {
  opacity: 0;
}
.loading-icon {
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite; /* Spin animation */
  margin: auto auto; /* Center the icon */
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
